import React from "react";
import { Button } from "./ui/button";
import { Menu, X } from "lucide-react";
import { useState } from "react";
import logo from "../assets/logo/logo.jpg";

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

    const scrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: "smooth" });
        }
        setIsMenuOpen(false);
    };

    return (
        <header className="bg-white shadow-sm border-b sticky top-0 z-50">
            <div className="container mx-auto px-6">
                <div className="flex items-center justify-between">
                    {/* Logo */}
                    <div className="flex items-center space-x-2 p-2">
                        {/* <div className="w-8 h-8 bg-gradient-to-r from-slate-800 to-slate-600 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-sm">GF</span>
            </div>
            <span className="text-xl font-bold text-slate-800">GenieFab</span> */}
                        <img src={logo} alt="" height="60px" width="60px" />
                    </div>

                    {/* Desktop Navigation */}
                    <nav className="hidden md:flex items-center space-x-8">
                        <button
                            onClick={() => scrollToSection("about")}
                            className="text-slate-600 hover:text-slate-800 transition-colors duration-200"
                        >
                            About
                        </button>
                        <button
                            onClick={() => scrollToSection("benefits")}
                            className="text-slate-600 hover:text-slate-800 transition-colors duration-200"
                        >
                            Benefits
                        </button>
                        <button
                            onClick={() => scrollToSection("how-it-works")}
                            className="text-slate-600 hover:text-slate-800 transition-colors duration-200"
                        >
                            How It Works
                        </button>
                        <button
                            onClick={() => scrollToSection("pricing")}
                            className="text-slate-600 hover:text-slate-800 transition-colors duration-200"
                        >
                            Pricing
                        </button>
                        <Button
                            className="bg-slate-800 hover:bg-slate-700 text-white px-6 py-2 rounded-lg transition-colors duration-200"
                            onClick={() =>
                                window.open("https://uat-app.geniefab.com")
                            }
                        >
                            Login / Dashboard
                        </Button>
                    </nav>

                    {/* Mobile Menu Button */}
                    <button
                        className="md:hidden text-slate-600 hover:text-slate-800"
                        onClick={toggleMenu}
                    >
                        {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
                    </button>
                </div>

                {/* Mobile Navigation */}
                {isMenuOpen && (
                    <div className="md:hidden mt-4 pb-4 border-t border-slate-200">
                        <nav className="flex flex-col space-y-4 mt-4">
                            <button
                                onClick={() => scrollToSection("about")}
                                className="text-left text-slate-600 hover:text-slate-800 transition-colors duration-200"
                            >
                                About
                            </button>
                            <button
                                onClick={() => scrollToSection("benefits")}
                                className="text-left text-slate-600 hover:text-slate-800 transition-colors duration-200"
                            >
                                Benefits
                            </button>
                            <button
                                onClick={() => scrollToSection("how-it-works")}
                                className="text-left text-slate-600 hover:text-slate-800 transition-colors duration-200"
                            >
                                How It Works
                            </button>
                            <button
                                onClick={() => scrollToSection("pricing")}
                                className="text-left text-slate-600 hover:text-slate-800 transition-colors duration-200"
                            >
                                Pricing
                            </button>
                            <Button
                                className="bg-slate-800 hover:bg-slate-700 text-white px-6 py-2 rounded-lg transition-colors duration-200 w-full"
                                onClick={() =>
                                    window.open("https://uat-app.geniefab.com")
                                }
                            >
                                Login / Dashboard
                            </Button>
                        </nav>
                    </div>
                )}
            </div>
        </header>
    );
};

export default Header;
